'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * # assign
 * Object.assign() polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
 *
 * @param {Object} target
 * @param {Object} varArgs
 * @return {Object}
 *
 * @example
 * assign({a: 1, b: 2}, {c: 3});
 *
 * @module helpers/polyfill/assign.js
 */
function assign(target) {
  if (target === null) {
    // TypeError if undefined or null
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var to = Object(target);

  for (var index = 1; index < arguments.length; index++) {
    var nextSource = arguments[index];

    // Skip over if undefined or null
    if (nextSource !== null) {
      for (var nextKey in nextSource) {
        // Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey];
        }
      }
    }
  }

  return to;
}

exports.default = assign;
module.exports = exports['default'];
//# sourceMappingURL=assign.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/helpers/polyfill/assign.js
// module id = 875
// module chunks = 0